import React from "react";
import { useQuery } from "@apollo/react-hooks";
import * as S from "./styles";
import { IProps } from "./types";
import { MY_VOUCHER } from "@molecules/MyVoucherModal/queries";
import { BreadCrumb, Loading } from "@atoms";
import { Container, Row, Col } from "react-bootstrap";
import { accountUrl } from "@src/app/routes";
import Divider from "@mui/material/Divider";
import { Voucher } from "@atoms/Voucher";
import { vouchers } from "@molecules/MyVoucherModal/__generated__/vouchers";

const MyVoucherPage: React.FC<IProps> = ({ }: IProps) => {

  const { data, error, loading } = useQuery<vouchers>(MY_VOUCHER, {});

  const breadCrumbData = [
    {
      name: "My Account",
      link: accountUrl
    },
    {
      name: "My Vouchers"
    }
  ];

  return (
    (data && (
      <S.Wrapper>
        <BreadCrumb data={breadCrumbData} />
        <S.HeaderWrapper>
          <S.Header>My Vouchers</S.Header>
        </S.HeaderWrapper>
        <Divider />
        <Container>
          <Row className="justify-content-md-center">
            <Col md={6} sm={12}>
              {
                data.availableVouchers.edges.map((voucher) => {
                  return (
                    <Voucher
                      key={voucher.node.id}
                      item={voucher.node}
                      onClickVoucher={() => { }}
                      showProduct={true}
                    />);
                })
              }
            </Col>
          </Row>
        </Container>
      </S.Wrapper>
    )) || <Loading />
  );
};

export { MyVoucherPage };
